module.exports = __webpack_public_path__ + "static/media/Terms_Geek2.a47634e1.jpg";